export default __webpack_public_path__ + "static/media/bilgilerim.daa6ed14.svg";